import gql from 'graphql-tag';

export { CREATE_PRODUCT } from './createProduct';

export const PRODUCT_PLANOGRAM_DETAIL_FRAGMENT = gql`
	fragment productPlanogramDetail on Product {
		id
		name
		imageUrl
		HCGCategory
		HFDCategory
		weight
		measurementUnit
		decrementQuantityOnSale
		overrideDynamicParlevelsSettings
		isFreshFood
		expiryDatePolicy
		barcodes
		tags {
			id
		}
		defaultPrice
		cost
	}
`;

export const MODIFY_PRODUCT_PACKAGING_FOR_TENANT = gql`
	mutation modifyProductPackagingForTenant(
		$productId: ID!,
		$tenantId: ID,
		$input: ModifyProductPackagingInput!
	) {
		modifyProductPackagingForTenant(
			productId: $productId,
			tenantId: $tenantId,
			input: $input
		) {
			id
			caseSize
			shipperSize
			palletSize
			tenantFieldOverrides
		}
	}
`;

export const SET_PRODUCT_STATES = gql`
	mutation setProductStates($productId: ID!, $stateTenantIds: [ID!]!) {
		setProductStates(productId: $productId, stateTenantIds: $stateTenantIds) {
			id
			tenants {
				id
				name
			}
		}
	}
`;

export const ADD_MASTER_PRODUCT_TO_STATE = gql`
	mutation addMasterProductToState($productId: ID!) {
		addMasterProductToState(productId: $productId) {
			id
			name
		}
	}
`;

export const DESTROY_PRODUCT = gql`
	mutation destroyProductMutation ($id: ID!) {
		destroyProduct(id: $id)
	}
`;

export const GET_PRODUCT_FROM_BARCODE = gql`
	query ($barcode: String) {
		getProductFromBarcode (barcode: $barcode) {
			id
			barcodes
			name
			imageUrl
			defaultPrice
			weight
			caseSize
			shipperSize
			palletSize
			forceQuantityInUnits
		}
	}
`;
